import React, {
    useEffect,
    useState,
    useRef,
} from "react";
import {
    Row,
    Col,
    Form,
    Input,
    Select,
    UploadImg,
    Button,
    useCRUDController
} from "../../../ui/ot";
import { useItem } from "../../controllers/ItemController";
import { useTranslation } from "react-i18next";
import { useAuthorisedValues } from "../../controllers/AuthorisedValuesController";
import { useLibrary } from "../../controllers/LibraryController";
import { Settings2 } from "lucide-react";
const ItemForm = ({
    keyPrefix = 'library.bookdetail',
    propsForm,
    onFormFinish = () => { },
    field,
    initialValues,
    isPropsOptions = false,
    propsOptions = {
        withdrawn_options: [],
        call_number_source_options: [],
        damaged_options: [],
        restricted_options: [],
        notforloan_options: [],
        collection_options: [],
        library_options: [],
        location_options: [],
        shelving_control_number_options: [],
        item_type_options: []
    },
    isSerial = true,
    hiddenFields = [],
    acquisitionSourceOptions,
    allowedItemTypeLabels,
    locationMenuPortalTarget,
    syncCopyNumberOnGenerate = true,

}) => {
    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_
    const [options, setOptions] = useState(propsOptions || {
        withdrawn_options: [],
        call_number_source_options: [],
        damaged_options: [],
        restricted_options: [],
        notforloan_options: [],
        collection_options: [],
        library_options: [],
        location_options: [],
        shelving_control_number_options: [],
        item_type_options: []
    })
    const { t } = useTranslation('translation', { keyPrefix })
    const getAnyFormValue = (name, count) => {
        let formValues = null;
        formValues = form.getFieldValue(name);
        return formValues;
    };
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
        if (!isPropsOptions) {
            getItem_ApiData({
                itemnumber: "0"
            })
                .then((response) => {
                    let datas = response?.data
                    let firstData = datas?.find((ele) => true)
                    setOptions((pre) => {
                        return {
                            withdrawn_options: firstData?.withdrawn_options,
                            call_number_source_options: firstData?.call_number_source_options,
                            damaged_options: firstData?.damaged_options,
                            restricted_options: firstData?.restricted_options,
                            notforloan_options: firstData?.notforloan_options,
                            collection_options: firstData?.collection_options,
                            library_options: firstData?.library_options,
                            location_options: firstData?.location_options,
                            shelving_control_number_options: firstData?.shelving_control_number_options,
                            item_type_options: firstData?.item_type_options,
                        }
                    })
                })
        }
    };

    const onFinish = (values) => {
        onFormFinish({
            ...values,
        });
    };
    const onValuesChange = (value, { name, type }) => {
        // let formValues = null;
        // form.getFieldsValue();

        // propsOnValuesChange(value)
    };
    const {
        getAuthorisedValuesData
    } = useAuthorisedValues({

    })
    const {
        getLibraryData
    } = useLibrary({})
    const {
        getItem_ApiData
    } = useItem({

    })
    useEffect(() => {
        setDataInitialization();
    }, []);

    useEffect(() => {
        if (!!isPropsOptions) {
            setOptions({ ...propsOptions })
        }
    }, [propsOptions])
    return (
        <Row>
            <Col span={24}>
                <Form
                    form={form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <FormItemComponent
                                keyPrefix={keyPrefix}
                                field={field}
                                initialValues={initialValues}
                                options={options}
                                isSerial={isSerial}
                                hiddenFields={hiddenFields}
                                acquisitionSourceOptions={acquisitionSourceOptions}
                                allowedItemTypeLabels={allowedItemTypeLabels}
                                locationMenuPortalTarget={locationMenuPortalTarget}
                                syncCopyNumberOnGenerate={syncCopyNumberOnGenerate}
                                setFieldValue={form.setFieldValue}
                                getAnyFormValue={getAnyFormValue}
                            />
                        </Col>
                    </Row>
                </Form>
            </Col>
        </Row>
    );
}
const FormItemComponent = ({
    keyPrefix,
    field,
    initialValues = {},
    options,
    isSerial = true,
    hiddenFields = [],
    acquisitionSourceOptions,
    allowedItemTypeLabels,
    locationMenuPortalTarget,
    syncCopyNumberOnGenerate = true,
    setFieldValue = () => { },
    getAnyFormValue = () => { }
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const tr = (key, defaultValue) => t(key, { defaultValue })
    const callNumberController = useCRUDController({ apiRoute: "/koha/item/callnumber" })
    const [loading, setLoading] = useState(false)
    const isFieldHidden = (name) => hiddenFields.includes(name)
    const getNextCopyNumber = (startCopyNumber, currentIndex) => {
        const [prefix, startNumStr] = startCopyNumber.split('.')
        const startNum = parseInt(startNumStr, 10)
        return `${prefix}.${startNum + currentIndex}`
    }
    return (
        <Row >
            <Col span={24}>
                <Row>
                    <Col>
                        <Form.Item
                            {...field}
                            name={[field?.name ?? '', 'biblionumber']}
                            fieldKey={[field?.fieldKey ?? '', 'biblionumber'].join('.')}
                            hidden={true}
                        >
                            <div></div>
                        </Form.Item>
                        <Form.Item
                            {...field}
                            name={[field?.name ?? '', 'biblio_id']}
                            fieldKey={[field?.fieldKey ?? '', 'biblio_id'].join('.')}
                            hidden={true}
                        >
                            <div></div>
                        </Form.Item>
                        <Form.Item
                            {...field}
                            name={[field?.name ?? '', 'itemnumber']}
                            fieldKey={[field?.fieldKey ?? '', 'itemnumber'].join('.')}
                            hidden={true}

                        >
                            <div></div>
                        </Form.Item>
                        <Form.Item
                            {...field}
                            name={[field?.name ?? '', 'serialid']}
                            fieldKey={[field?.fieldKey ?? '', 'serialid'].join('.')}
                            hidden={true}
                        >
                            <div></div>
                        </Form.Item>
                    </Col>
                </Row>
            </Col>
            {!isFieldHidden('file_id') && (
                <Col xxl={3} xl={3} lg={3} md={4} sm={6} xs={24} >
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'file_id']}
                        fieldKey={[field?.fieldKey ?? '', 'file_id']}
                        hidden={true}
                    >
                        <div></div>
                    </Form.Item>
                    <UploadImg
                        defaultValue={getAnyFormValue([field?.name ?? "", 'file_id']) ? [{ file_id: getAnyFormValue([field?.name ?? "", 'file_id']) }] : []}
                        // defaultValue={[{ file_id: 4762 }]}
                        api="/component/file"
                        onImagesChange={(data) => {
                            let firstData = data?.find((ele) => true)
                            let editName = [field?.name ?? "", 'file_id'].join('.')
                            setFieldValue(editName, firstData?.file_id)
                        }}
                    />
                </Col>
            )}
            <Col xxl={21} xl={21} lg={21} md={20} sm={18} xs={24}>
                <Row>
                    { /* a - Home library => home_library_id */}
                    <Col xxl={4} lg={4} md={8} sm={12} xs={24}>
                        <Form.Item
                            labelCol={24}
                            wrapperCol={24}
                            {...field}
                            name={[field?.name ?? '', 'home_library_id']}
                            fieldKey={[field?.fieldKey ?? '', 'home_library_id']}
                            label={`${tr('home_library', '所屬圖書館')}`}
                            labelStyle={{ color: "red" }}
                            rules={[{
                                required: true,
                                message: 'Please input name'
                            }]}
                        >
                            <Select
                                allowClear={true}
                                options={options?.library_options?.map((value, index) => ({
                                    label: value?.lib_opac,
                                    value: value?.authorised_value,
                                }))} />
                        </Form.Item>
                    </Col>
                    { /* b - Current library => holding_library_id */}

                    <Col xxl={4} lg={4} md={8} sm={12} xs={24}>
                        <Form.Item
                            labelCol={24}
                            wrapperCol={24}
                            {...field}
                            name={[field?.name ?? '', 'holding_library_id']}
                            fieldKey={[field?.fieldKey ?? '', 'holding_library_id']}
                            label={`${tr('current_library', '當前所在圖書館')}`}
                            initialValue={initialValues?.holding_library_id}
                            labelStyle={{ color: "red" }}
                            rules={[{
                                required: true,
                                message: 'Please input name'
                            }]}
                        >
                            <Select
                                allowClear={true}

                                options={options?.library_options?.map((value, index) => ({
                                    label: value?.lib_opac,
                                    value: value?.authorised_value,
                                }))} />
                        </Form.Item>
                    </Col>
                    { /* y - item type => item_type_id */}
                    <Col xxl={4} lg={4} md={8} sm={12} xs={24}>
                        <Form.Item
                            {...field}
                            labelCol={24}
                            wrapperCol={24}
                            name={[field?.name ?? '', 'item_type_id']}
                            fieldKey={[field?.fieldKey ?? '', 'item_type_id']}
                            label={`${tr('item_type', '館藏類型')}`}
                            initialValue={initialValues?.item_type_id}
                            labelStyle={{ color: "red" }}
                            rules={[{
                                required: true,
                                message: 'Please input name'
                            }]}
                        >
                            <Select
                                allowClear={true}
                                options={options?.item_type_options
                                    ?.filter((value) => !allowedItemTypeLabels || allowedItemTypeLabels.includes(value?.lib_opac?.trim()))
                                    ?.map((value) => ({
                                        label: allowedItemTypeLabels ? value?.lib_opac?.trim() : value?.lib_opac,
                                        value: value?.authorised_value,
                                    }))} />
                        </Form.Item>
                    </Col>
                    { /* p - Barcode => external_id */}
                    <Col xxl={4} lg={4} md={8} sm={12} xs={24}>
                        <Form.Item
                            labelCol={24}
                            wrapperCol={24}
                            {...field}
                            name={[field?.name ?? '', 'external_id']}
                            fieldKey={[field?.fieldKey ?? '', 'external_id']}
                            label={`${tr('barcode', '條碼')}`}
                            initialValue={initialValues?.external_id}
                            labelStyle={{ color: "red" }}
                            rules={[{
                                required: true,
                                message: 'Please input name'
                            }]}
                        >
                            <Input placeholder="請輸入" />
                        </Form.Item>
                    </Col>
                    { /* p - Barcode => external_id */}
                    <Col xxl={4} lg={4} md={8} sm={12} xs={24}>
                        <Form.Item
                            labelCol={24}
                            wrapperCol={24}
                            {...field}
                            name={[field?.name ?? '', 'internal_notes']}
                            fieldKey={[field?.fieldKey ?? '', 'internal_notes']}
                            label={`${tr('attachment', '附件')}`}

                        >
                            <Input placeholder="請輸入" />
                        </Form.Item>
                    </Col>
                    { /* h - Serial enumeration / chronology => serial_issue_number */}
                    <Col xxl={4} lg={4} md={8} sm={12} xs={24}>
                        <Form.Item
                            labelCol={24}
                            wrapperCol={24}
                            {...field}
                            name={[field?.name ?? '', 'serial_issue_number']}
                            fieldKey={[field?.fieldKey ?? '', 'serial_issue_number']}
                            label={`${tr('serial_enumeration_chronology', '刊期')}`}
                            initialValue={initialValues?.serial_issue_number}
                            labelStyle={{ color: isSerial ? "red" : "" }}
                            rules={[{
                                required: isSerial,
                                message: '請輸入'
                            }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    { /* 0 - Withdrawn status => withdrawn */}
                    <Col xxl={4} lg={4} md={8} sm={12} xs={24}  >
                        <Form.Item
                            labelCol={24}
                            wrapperCol={24}
                            {...field}
                            name={[field?.name ?? '', 'withdrawn']}
                            fieldKey={[field?.fieldKey ?? '', 'withdrawn'].join('.')}
                            label={`${tr('withdrawn_status', '停用狀態')}`}
                            initialValue={initialValues?.withdrawn}
                        >
                            <Select
                                allowClear={true}
                                options={[

                                    ...options?.withdrawn_options?.map((value, index) => {
                                        return {
                                            label: value?.lib_opac,
                                            value: `${value?.authorised_value}`
                                        }
                                    })]} />
                        </Form.Item>
                    </Col>
                    { /* 2 - Withdrawn date => withdrawn_date */}

                    <Col xxl={4} lg={4} md={8} sm={12} xs={24} hidden={isFieldHidden('call_number_source')}>
                        <Form.Item
                            labelCol={24}
                            wrapperCol={24}
                            {...field}
                            name={[field?.name ?? '', 'call_number_source']}
                            fieldKey={[field?.fieldKey ?? '', 'call_number_source'].join('.')}
                            label={`${tr('source_classification_shelving_scheme', '分類或上架方案來源')}`}
                            initialValue={initialValues?.call_number_source}
                        >
                            <Select
                                allowClear={true}
                                options={options?.call_number_source_options?.map((value, index) => ({
                                    label: value?.lib_opac,
                                    value: value?.authorised_value
                                }))} />
                        </Form.Item>
                    </Col>
                    { /* 3 - Materials specified => materials_notes */}

                    <Col xxl={4} lg={4} md={8} sm={12} xs={24}>
                        <Form.Item
                            labelCol={24}
                            wrapperCol={24}
                            {...field}
                            name={[field?.name ?? '', 'materials_notes']}
                            fieldKey={[field?.fieldKey ?? '', 'materials_notes']}
                            label={`${tr('specified_materials', '材料（裝訂卷冊或其他部分）')}`}
                            initialValue={initialValues?.materials_notes}

                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    { /* 4 - Damaged status => damaged_status */}
                    <Col xxl={4} lg={4} md={8} sm={12} xs={24}>
                        <Form.Item
                            labelCol={24}
                            wrapperCol={24}
                            {...field}
                            name={[field?.name ?? '', 'damaged_status']}
                            fieldKey={[field?.fieldKey ?? '', 'damaged_status']}
                            label={`${tr('damaged_status', '損壞狀態')}`}
                            initialValue={initialValues?.damaged_status}
                        >
                            <Select
                                allowClear={true}

                                options={options?.damaged_options?.map((value, index) => ({
                                    label: value?.lib_opac,
                                    value: value?.authorised_value
                                }))} />
                        </Form.Item>
                    </Col>

                    { /* 5 - Use restrictions => restricted_status */}
                    <Col xxl={4} lg={4} md={8} sm={12} xs={24}>
                        <Form.Item
                            labelCol={24}
                            wrapperCol={24}
                            {...field}
                            name={[field?.name ?? '', 'restricted_status']}
                            fieldKey={[field?.fieldKey ?? '', 'restricted_status']}
                            label={`${tr('use_restrictions', '使用限制')}`}
                            initialValue={initialValues?.restricted_status}
                        >
                            <Select
                                allowClear={true}

                                options={options?.restricted_options?.map((value, index) => ({
                                    label: value?.lib_opac,
                                    value: value?.authorised_value
                                }))} />
                        </Form.Item>
                    </Col>

                    { /* 6 - Not for loan => not_for_loan_status */}
                    <Col xxl={4} lg={4} md={8} sm={12} xs={24}>
                        <Form.Item
                            labelCol={24}
                            wrapperCol={24}
                            {...field}
                            name={[field?.name ?? '', 'not_for_loan_status']}
                            fieldKey={[field?.fieldKey ?? '', 'not_for_loan_status']}
                            label={`${tr('not_for_loan', '不外借')}`}
                            labelStyle={{ color: isSerial ? "blue" : "" }}

                        >
                            <Select
                                allowClear={true}
                                options={options?.notforloan_options?.map((value, index) => ({
                                    label: value?.lib_opac,
                                    value: value?.authorised_value
                                }))} />
                        </Form.Item>
                    </Col>
                    { /* o - Full call number => callnumber */}
                    <Col xxl={8} lg={8} md={16} sm={24} xs={24}>
                        <Row align="middle">
                            <Col xxl={16} lg={18} md={18} sm={16} xs={24}>
                                <Form.Item
                                    labelCol={24}
                                    wrapperCol={24}
                                    {...field}
                                    name={[field?.name ?? '', 'callnumber']}
                                    fieldKey={[field?.fieldKey ?? '', 'callnumber']}
                                    label={`${tr('full_call_number', '完整索書號')}`}
                                    initialValue={initialValues?.callnumber}
                                >
                                    <Input placeholder="請輸入" />
                                </Form.Item>
                            </Col>
                            <Col xxl={6} lg={6} md={6} sm={8} xs={24}>
                                <Button
                                    loading={loading}
                                    block={true}
                                    type="icon"
                                    onClick={() => {
                                        setLoading(true)
                                        let biblionumber = getAnyFormValue([field?.name ?? "", 'biblio_id']) ? getAnyFormValue([field?.name ?? "", 'biblio_id']) : getAnyFormValue([field?.name ?? "", 'biblionumber'])
                                        let serialid = getAnyFormValue([field?.name ?? "", 'serialid']) ? getAnyFormValue([field?.name ?? "", 'serialid']) : getAnyFormValue([field?.name ?? "", 'serialid'])
                                        let serial_issue_number = getAnyFormValue([field?.name ?? "", 'serial_issue_number']) ? getAnyFormValue([field?.name ?? "", 'serial_issue_number']) : getAnyFormValue([field?.name ?? "", 'serial_issue_number'])
                                       
                                        //如果是期刊內容
                                        let params = isSerial && serialid ?
                                            {
                                                serialid
                                            } :
                                            {
                                                biblionumber
                                            }

                                        callNumberController.getData({
                                            ...params
                                        })
                                            .then((response) => {
                                                let data = response?.data
                                                let firstData = data?.find((ele) => true)
                                                let path = field?.name
                                                let lastPart = parseInt(path.split('.').pop() || 0) ?? 0
                                                let nextCopyNumber = getNextCopyNumber(firstData?.copynumber, lastPart)

                                                // 館藏分類代碼 分類號 作者號 年份 複本號

                                                if (isSerial) {
                                                    let tempCallnumber = `${firstData?.itemtype || ""} ${firstData?.cn_class || ""} ${firstData?.cn_item || ""} ${firstData?.publicationyear || ""}  ${serial_issue_number || ""}`
                                                    //  期刊
                                                    if (!!serialid) {
                                                        let newCallNumber = `${firstData?.itemcallnumber || ""}`
                                                        let editName = [field?.name ?? "", 'callnumber'].join('.')
                                                        let editCopyNumberName = [field?.name ?? "", 'copy_number'].join('.')
                                                        setFieldValue(editName, newCallNumber)
                                                        if (syncCopyNumberOnGenerate) {
                                                            setFieldValue(editCopyNumberName, `${firstData?.copynumber || ""}`)
                                                        }
                                                    }
                                                    else {
                                                        let newCallNumber = tempCallnumber
                                                        let editName = [field?.name ?? "", 'callnumber'].join('.')
                                                        let editCopyNumberName = [field?.name ?? "", 'copy_number'].join('.')
                                                        setFieldValue(editName, newCallNumber)
                                                        if (syncCopyNumberOnGenerate) {
                                                            setFieldValue(editCopyNumberName, `${newCallNumber || ""}`)
                                                        }
                                                    }

                                                }
                                                else {
                                                    // 一般館藏
                                                    let newCallNumber = `${firstData?.itemtype || ""} ${firstData?.cn_class || ""} ${firstData?.cn_item || ""} ${firstData?.publicationyear || ""} ${nextCopyNumber || ""}`
                                                    let editName = [field?.name ?? "", 'callnumber'].join('.')
                                                    let editCopyNumberName = [field?.name ?? "", 'copy_number'].join('.')
                                                    setFieldValue(editName, newCallNumber)
                                                    if (syncCopyNumberOnGenerate) {
                                                        setFieldValue(editCopyNumberName, nextCopyNumber)
                                                    }
                                                }


                                            })
                                            .finally(() => {
                                                setLoading(false)
                                            })
                                    }}
                                >
                                    <Settings2 size={14} />
                                </Button>
                            </Col>
                        </Row>

                    </Col>
                    { /* 8 - Collection => collection_code */}

                    <Col xxl={4} lg={4} md={8} sm={12} xs={24} hidden={true} >
                        <Form.Item
                            labelCol={24}
                            wrapperCol={24}
                            {...field}
                            name={[field?.name ?? '', 'collection_code']}
                            fieldKey={[field?.fieldKey ?? '', 'collection_code']}
                            label={`${tr('collection', '館藏集')}`}
                            initialValue={initialValues?.collection_code}
                            hidden={true}
                        >
                            <Select
                                hidden={true}
                                allowClear={true}
                                options={options?.collection_options?.map((value, index) => ({
                                    label: value?.lib_opac,
                                    value: value?.authorised_value
                                }))} />
                        </Form.Item>
                    </Col>


                    { /* c - Shelving location => location */}

                    <Col xxl={4} lg={4} md={8} sm={12} xs={24} hidden={isFieldHidden('location')}>
                        <Form.Item
                            labelCol={24}
                            wrapperCol={24}
                            {...field}
                            name={[field?.name ?? '', 'location']}
                            fieldKey={[field?.fieldKey ?? '', 'location']}
                            label={`${tr('shelving_location', '擺放位置')}`}
                            initialValue={initialValues?.location}
                        >
                            <Select
                                allowClear={true}
                                menuPortalTarget={locationMenuPortalTarget}
                                options={options?.location_options?.map((value, index) => ({
                                    label: value?.lib_opac,
                                    value: value?.authorised_value,
                                }))} />
                        </Form.Item>
                    </Col>
                    { /* d - Date acquired => acquisition_date */}
                    <Col xxl={4} lg={4} md={8} sm={12} xs={24}>
                        <Form.Item
                            labelCol={24}
                            wrapperCol={24}
                            {...field}
                            name={[field?.name ?? '', 'acquisition_date']}
                            fieldKey={[field?.fieldKey ?? '', 'acquisition_date']}
                            label={`${tr('date_acquired', '入館日期')}`}
                            initialValue={initialValues?.acquisition_date}
                        >
                            <Input type="date" />
                        </Form.Item>
                    </Col>

                    { /* e - Source of acquisition => acquisition_source */}
                    <Col xxl={4} lg={4} md={8} sm={12} xs={24} hidden={isFieldHidden('acquisition_source')}>
                        <Form.Item
                            labelCol={24}
                            wrapperCol={24}
                            {...field}
                            name={[field?.name ?? '', 'acquisition_source']}
                            fieldKey={[field?.fieldKey ?? '', 'acquisition_source']}
                            label={`${tr('source_acquisition', '取得來源')}`}
                            initialValue={initialValues?.acquisition_source}
                        >
                            {acquisitionSourceOptions ? (
                                <Select
                                    allowClear={true}
                                    options={acquisitionSourceOptions}
                                    placeholder="請選擇..."
                                />
                            ) : (
                                <Input placeholder="請輸入..." />
                            )}
                        </Form.Item>
                    </Col>

                    { /* f - Coded location qualifier => coded_location_qualifier */}
                    <Col xxl={4} lg={4} md={8} sm={12} xs={24} hidden={isFieldHidden('coded_location_qualifier')}>
                        <Form.Item
                            labelCol={24}
                            wrapperCol={24}
                            {...field}
                            name={[field?.name ?? '', 'coded_location_qualifier']}
                            fieldKey={[field?.fieldKey ?? '', 'coded_location_qualifier']}
                            label={`${tr('coded_location_qualifier', '地點代碼')}`}
                            initialValue={initialValues?.coded_location_qualifier}
                        >
                            <Input placeholder="請輸入..." />
                        </Form.Item>
                    </Col>

                    { /* g - Cost, normal purchase price => purchase_price */}
                    <Col xxl={4} lg={4} md={8} sm={12} xs={24}>
                        <Form.Item
                            labelCol={24}
                            wrapperCol={24}
                            {...field}
                            name={[field?.name ?? '', 'purchase_price']}
                            fieldKey={[field?.fieldKey ?? '', 'purchase_price']}
                            label={`${tr('cost_normal_price', '成本，正常購買價格')}`}
                            initialValue={initialValues?.purchase_price}
                        >
                            <Input placeholder="請輸入數值" />
                        </Form.Item>
                    </Col>

                    { /* i - Inventory number => inventory_number */}
                    <Col xxl={4} lg={4} md={8} sm={12} xs={24} hidden={isFieldHidden('inventory_number')}>
                        <Form.Item
                            labelCol={24}
                            wrapperCol={24}
                            {...field}
                            name={[field?.name ?? '', 'inventory_number']}
                            fieldKey={[field?.fieldKey ?? '', 'inventory_number']}
                            label={`${tr('inventory_number', '庫存號')}`}
                            initialValue={initialValues?.inventory_number}

                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    { /* j - Shelving control number => shelving_control_number */}
                    <Col xxl={4} lg={4} md={8} sm={12} xs={24} hidden={isFieldHidden('shelving_control_number')}>
                        <Form.Item
                            labelCol={24}
                            wrapperCol={24}
                            {...field}
                            name={[field?.name ?? '', 'shelving_control_number']}
                            fieldKey={[field?.fieldKey ?? '', 'shelving_control_number']}
                            label={`${tr('shelving_control_number', '架位控制號')}`}
                            initialValue={initialValues?.shelving_control_number}

                        >
                            <Select
                                allowClear={true}
                                options={options?.shelving_control_number_options?.map((value, index) => ({
                                    label: value?.lib_opac,
                                    value: value?.authorised_value,
                                }))} />
                        </Form.Item>
                    </Col>


                    { /* t - Copy number => copy_number */}
                    <Col xxl={4} lg={4} md={8} sm={12} xs={24}>
                        <Form.Item
                            labelCol={24}
                            wrapperCol={24}
                            {...field}
                            name={[field?.name ?? '', 'copy_number']}
                            fieldKey={[field?.fieldKey ?? '', 'copy_number']}
                            label={`${tr('copy_number', '複本號')}`}
                            initialValue={initialValues?.copy_number}

                        >
                            <Input placeholder="請輸入" />
                        </Form.Item>
                    </Col>
                    { /* u - Uniform resource identifier => uri */}
                    <Col xxl={4} lg={4} md={8} sm={12} xs={24} hidden={isFieldHidden('uri')}>
                        <Form.Item
                            labelCol={24}
                            wrapperCol={24}
                            {...field}
                            name={[field?.name ?? '', 'uri']}
                            fieldKey={[field?.fieldKey ?? '', 'uri']}
                            label={`${tr('uniform_resource_identifier', '統一資源標識符')}`}
                            initialValue={initialValues?.uri}

                        >
                            <Input placeholder="請輸入" />
                        </Form.Item>
                    </Col>
                    { /* v - Cost, replacement price => replacement_price */}
                    <Col xxl={4} lg={4} md={8} sm={12} xs={24} hidden={isFieldHidden('replacement_price')}>
                        <Form.Item
                            labelCol={24}
                            wrapperCol={24}
                            {...field}
                            name={[field?.name ?? '', 'replacement_price']}
                            fieldKey={[field?.fieldKey ?? '', 'replacement_price']}
                            label={`${tr('replacement_cost', '成本，替換價格')}`}
                            initialValue={initialValues?.replacement_price}

                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    { /* w - Price effective from => replacement_price_date */}
                    <Col xxl={4} lg={4} md={8} sm={12} xs={24} hidden={isFieldHidden('replacement_price_date')}>
                        <Form.Item
                            labelCol={24}
                            wrapperCol={24}
                            {...field}
                            name={[field?.name ?? '', 'replacement_price_date']}
                            fieldKey={[field?.fieldKey ?? '', 'replacement_price_date']}
                            label={`${tr('price_effective_from', '價格生效日期')}`}
                            initialValue={initialValues?.replacement_price_date}
                        >
                            <Input type="date" placeholder="請輸入日期" />
                        </Form.Item>
                    </Col>


                    { /* z - Public note => public_notes */}
                    <Col xxl={4} lg={4} md={8} sm={12} xs={24}>
                        <Form.Item
                            {...field}
                            labelCol={24}
                            wrapperCol={24}
                            name={[field?.name ?? '', 'public_notes']}
                            fieldKey={[field?.fieldKey ?? '', 'public_notes']}
                            label={`${tr('public_note', '公開備註')}`}
                            initialValue={initialValues?.public_notes}
                        >
                            <Input placeholder="請輸入" />
                        </Form.Item>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};
export { ItemForm }
